export const formatRelativeTime = (time) => {
  const createdAt = new Date(time).getTime();

  if (Number.isNaN(createdAt)) {
    return "";
  }

  const diffMs = Math.max(0, Date.now() - createdAt);
  const minute = 1000 * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const week = day * 7;
  const month = day * 30;
  const year = day * 365;

  if (diffMs < hour) {
    const count = Math.max(1, Math.floor(diffMs / minute));
    return `${count} minute${count === 1 ? "" : "s"} ago`;
  }

  if (diffMs < day) {
    const count = Math.floor(diffMs / hour);
    return `${count} hour${count === 1 ? "" : "s"} ago`;
  }

  if (diffMs < week) {
    const count = Math.floor(diffMs / day);
    return `${count} day${count === 1 ? "" : "s"} ago`;
  }

  if (diffMs < month) {
    const count = Math.floor(diffMs / week);
    return `${count} week${count === 1 ? "" : "s"} ago`;
  }

  if (diffMs < year) {
    const count = Math.floor(diffMs / month);
    return `${count} month${count === 1 ? "" : "s"} ago`;
  }

  const count = Math.floor(diffMs / year);
  return `${count} year${count === 1 ? "" : "s"} ago`;
};
